import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GridOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GridOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6C3.79 2 2 3.79 2 6v12c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4Zm2 4v2h-7V4h5c1.1 0 2 .9 2 2Zm-7 4h7v4h-7v-4Zm-2 4H4v-4h7v4ZM6 4h5v4H4V6c0-1.1.9-2 2-2ZM4 18v-2h7v4H6c-1.1 0-2-.9-2-2Zm14 2h-5v-4h7v2c0 1.1-.9 2-2 2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default GridOutlined;